import { z } from 'zod';

/** Runtime 削除ジョブ API で許可する環境名 */
export const RuntimeDeleteEnvironmentSchema = z.enum([
  'dev',
  'stg',
  'prod',
  'feature',
]);

/** DELETE /api/delete-jobs/runtime/{orch_runtimeenv_id} のレスポンス */
export const DeleteRuntimeJobResponseSchema = z.object({
  job_id: z.string(),
  request_id: z.string().nullable(),
  status: z.string(),
});

/** Runtime 削除ジョブ API リクエストの env 型 */
export type RuntimeDeleteEnvironment = z.infer<
  typeof RuntimeDeleteEnvironmentSchema
>;

/** Runtime 削除ジョブ API レスポンス型 */
export type DeleteRuntimeJobResponse = z.infer<
  typeof DeleteRuntimeJobResponseSchema
>;
